import { FaStar } from 'react-icons/fa';

interface Review {
  id: number;
  name: string;
  avatar: string;
  rating: number;
  testimonial: string;
  location: string;
}

const reviews: Review[] = [
  {
    id: 1,
    name: 'Budi Santoso, Karyawan kantor',
    avatar: '/avatar-1.jpg',
    rating: 5,
    testimonial:
      'Gak sempat cek akun tiap hari, SMARTSECURE kasih peringatan real-time pas ada kebocoran. Praktis, gak perlu install aplikasi tambahan.',
    location: 'Jakarta',
  },
  {
    id: 2,
    name: 'Sari Wijaya, Ibu Rumah Tangga',
    avatar: '/avatar-2.jpg',
    rating: 5,
    testimonial:
      'Aku pakai Gmail buat semua urusan kerja. SMARTSECURE bantu pantau akunku biar gak keblokir. Beneran worth it!',
    location: 'Surabaya',
  },
  {
    id: 3,
    name: 'Ahmad Rahman, Freelancer',
    avatar: '/avatar-3.jpg',
    rating: 4,
    testimonial:
      'SMARTSECURE kasih peringatan sebelum ada transaksi mencurigakan. Belanja online lebih tenang, data bank tetap aman',
    location: 'Bandung',
  },
];

export default function CustomerReviews() {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <FaStar
        key={index}
        className={`text-sm ${
          index < rating ? 'text-yellow-400' : 'text-gray-300'
        }`}
      />
    ));
  };

  return (
    <section className="mb-6">
      <h2 className="text-xl font-bold mb-6 text-center">
        Kata Pengguna <span className="text-[#3723B5]">SmartSecure</span>
      </h2>

      <div className="space-y-4">
        {reviews.map((review) => (
          <div
            key={review.id}
            className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"
          >
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-[#3723B5]/20"
                  onError={(e) => {
                    // Fallback to placeholder if image fails to load
                    e.currentTarget.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                      review.name
                    )}&background=3723B5&color=ffffff&size=48`;
                  }}
                />
              </div>

              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <div>
                    <h4 className="font-semibold text-sm text-gray-900">
                      {review.name}
                    </h4>
                    <p className="text-xs text-gray-500">{review.location}</p>
                  </div>
                  <div className="flex items-center space-x-1">
                    {renderStars(review.rating)}
                  </div>
                </div>

                <p className="text-sm text-gray-700 leading-relaxed">
                  "{review.testimonial}"
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-6">
        <p className="text-xs text-gray-500">
          Lebih dari <span className="font-bold text-[#3723B5]">10,000+</span>{' '}
          pengguna mempercayai SmartSecure
        </p>
      </div>
    </section>
  );
}
